export { Tooltip, type TooltipProps } from "./Tooltip.component";
